var render, staticRenderFns
import script from "./publicList.vue?vue&type=script&lang=js&"
export * from "./publicList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19f95536",
  null
  
)

export default component.exports